import axios from "axios";
import { lexaProxyHeaders, lexaProxyUrl, withCorpAuth } from "./lexaProxyAuth";

const axiosLexaApi = withCorpAuth(
  axios.create({
    baseURL: lexaProxyUrl,
    headers: lexaProxyHeaders,
    withCredentials: true,
  })
);

export default axiosLexaApi;
